import { calculateDays } from '$components/Screens/AdditionalVideosScreen/utils';
import { GetCandidateSmartInterviewsVideosOutput } from '$store/modules/smart-interviews';
import { getVideoThumbnail } from '$utils/getVideoThumbnail';
import { ReactComponent as Display } from '$icons/Eye.svg';
import { ReactComponent as Hidden } from '$icons/EyeOff.svg';
import { useEffect, useState } from 'react';

const SingleSmartInterviewVideo = ({
  video,
  onClick,
  openVisibilityModal,
}: {
  video: GetCandidateSmartInterviewsVideosOutput[number];
  onClick: (video: GetCandidateSmartInterviewsVideosOutput[number]) => void;
  openVisibilityModal: (selectedVideo: {
    videoId: number;
    isVisible: boolean;
  }) => void;
}) => {
  const [videoThumbnail, setVideoThumbnail] = useState('');

  useEffect(() => {
    (async () => {
      const image = await getVideoThumbnail(video.Url);
      setVideoThumbnail(image);
    })();
  }, [video]);

  return (
    <div className="rounded-sm shadow overflow-hidden relative">
      <button
        className="absolute right-2 top-2 bg-black/20 p-2 rounded-xl"
        type="button"
        onClick={() =>
          openVisibilityModal({ videoId: video.Id, isVisible: video.IsVisible })
        }
      >
        {video.IsVisible ? (
          <Display className="w-4 h-4" />
        ) : (
          <Hidden className="w-4 h-4" />
        )}
      </button>
      <button type="button" onClick={() => onClick(video)} className="w-full">
        <img
          src={videoThumbnail}
          alt={video.SmartInterviewQuestions?.Name}
          className="w-full min-h-52 object-cover object-center"
        />
        <div className="text-left py-2 px-4">
          <div className="font-semibold mb-2">
            {video.SmartInterviewQuestions?.Name}
          </div>
          <div className="text-xs text-gray-500">
            {calculateDays(video.CreateTime)}
          </div>
        </div>
      </button>
    </div>
  );
};

export default SingleSmartInterviewVideo;
